export default __webpack_public_path__ + "static/media/entenda_2_costas.74142fe1.jpg";